exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.layer[data-v-004b2e69] {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}", ""]);

// exports
